module.exports = __webpack_public_path__ + "img/doc-icon.338ee5c2.svg";